import { type AuthSnapshot, getAuthSnapshot, subscribeAuth } from '@services/auth';
import { type SyncSnapshot, getSyncSnapshot, subscribeSync } from '@services/sync';
import { useSyncExternalStore } from 'preact/compat';

export function useAuth(): AuthSnapshot {
  return useSyncExternalStore(subscribeAuth, getAuthSnapshot);
}

export function useSync(): SyncSnapshot {
  return useSyncExternalStore(subscribeSync, getSyncSnapshot);
}
